import type { CityConfig } from "@/pages/city-template/types";

export const buffaloConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Buffalo",
  state: "New York",
  stateAbbr: "NY",
  slug: "buffalo",
  route: "/buffalo",
  title: "Emergency Passport Buffalo, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Buffalo, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Buffalo business travelers, UB students, Niagara Falls cross-border commuters, and Western New York families.",
  h1: "Emergency & Expedited Passport Services in Buffalo, NY",
  heroSubtitle: "BUF flight to Cancun departing in 6 days? Weekend trip to Toronto and your passport just expired? UB study abroad program starting in Florence? We help Buffalo residents — from Elmwood Village professionals to Amherst families to Niagara Falls border commuters — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20downtown%20Buffalo%20New%20York%20skyline%20at%20golden%20hour%20with%20the%20historic%20art%20deco%20City%20Hall%20building%20and%20modern%20glass%20architecture%20along%20Lake%20Erie%20waterfront%2C%20dramatic%20sunset%20clouds%20reflecting%20warm%20amber%20light%20on%20the%20water%2C%20clean%20urban%20landscape%20with%20no%20readable%20text%20or%20signs%2C%20professional%20architectural%20photography%20with%20rich%20warm%20tones&width=1800&height=700&seq=buffalo-hero-2026-v2&orientation=landscape",
  heroImageAlt: "Buffalo New York downtown skyline with City Hall and Lake Erie waterfront at golden hour",
  geoPosition: "42.8864;-78.8784",
  geoPlacename: "Buffalo, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Buffalo Passport Agency",
    address: "111 Genesee Street Suite 101, Buffalo, NY 14203",
    distance: "Located in downtown Buffalo — visit in person or use our courier service",
  },
  nearbyCitiesZips: [
    { name: "Buffalo", zips: "14201–14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263–14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "Amherst", zips: "14226, 14228, 14231, 14068" },
    { name: "Cheektowaga", zips: "14225, 14227, 14215, 14206, 14211" },
    { name: "Tonawanda", zips: "14150, 14217, 14223" },
    { name: "North Tonawanda", zips: "14120" },
    { name: "Niagara Falls", zips: "14301–14305" },
    { name: "West Seneca", zips: "14218, 14224" },
    { name: "Lackawanna", zips: "14218" },
    { name: "Kenmore", zips: "14217" },
    { name: "Hamburg", zips: "14075" },
    { name: "Orchard Park", zips: "14127" },
    { name: "Williamsville", zips: "14221" },
    { name: "Clarence", zips: "14031, 14032" },
    { name: "Lancaster", zips: "14086" },
    { name: "Depew", zips: "14043" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Buffalo Passport Agency — as fast as 24 hours for Buffalo-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "Buffalo Niagara Airport Expertise", desc: "BUF handles 5M+ passengers annually. We know airline schedules, seasonal routes to Florida and the Caribbean, and last-minute booking patterns." },
    { icon: "ri-flag-line", title: "Cross-Border Canada Travel Ready", desc: "Buffalo to Toronto is 90 minutes. We handle enhanced license vs passport rules, Nexus considerations, and Canadian entry requirements." },
    { icon: "ri-graduation-cap-line", title: "UB & WNY College Expedited", desc: "University at Buffalo, Buffalo State, Canisius, Niagara University — we guide students and faculty through study abroad and conference passport timelines." },
  ],
  internalLinks: [
    { name: "Fast passport services in New York City", route: "/new-york-city" },
    { name: "Expedited passport in Albany, NY", route: "/albany-ny" },
    { name: "Quick passport services in Syracuse, NY", route: "/syracuse" },
    { name: "Urgent passport services in Rochester", route: "/rochester" },
    { name: "New York State passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Buffalo via secure registered courier with direct access to the Buffalo Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results with the agency right here in downtown Buffalo. Buffalo residents can ship from any UPS Store, FedEx Office, or post office location across Erie County.",
  fpcOfficeDistance: "Serving Buffalo, Amherst, Cheektowaga, Tonawanda, Niagara Falls, and all Western New York communities — the Buffalo Passport Agency is located at 111 Genesee Street Suite 101",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Buffalo and all of Western New York. From the Elmwood Village and Allentown to the Northtowns of Amherst and Tonawanda, from the Southtowns of Hamburg and Orchard Park to Niagara Falls and beyond — we serve all of Erie County and Niagara County. Our courier service gives you direct access to the Buffalo Passport Agency — right here in your hometown.",
  nearbyCitiesIntro: "We serve Buffalo and all Western New York communities including Amherst, Cheektowaga, Tonawanda, North Tonawanda, Niagara Falls, West Seneca, Hamburg, Orchard Park, Williamsville, Clarence, Lancaster, and Depew. We also serve travelers departing from Buffalo Niagara International Airport and those crossing into Canada at the Peace Bridge, Rainbow Bridge, and Lewiston-Queenston Bridge.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Buffalo as simple as possible — with the efficiency and reliability Western New York executives, UB students, and Niagara Region families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Buffalo travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Buffalo travelers encounter unique passport issues — everything from Canadian border crossing confusion to last-minute Florida snowbird bookings. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Buffalo travelers — from downtown professionals to Amherst families to Niagara Falls border commuters — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Buffalo, NY? Here are the most common ones we hear from Western New York travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a BUF flight to Cancun, an emergency passport for a last-minute Toronto business meeting, or a first-time passport for a UB student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingIntro: "Buffalo travelers — UB students studying abroad, M&T Bank executives heading overseas, and Western New York families flying out of Buffalo Niagara International Airport to Florida and the Caribbean — have several options for getting a passport fast. Here is how they compare, and why most Western New York residents choose a U.S. Department of State registered passport courier for predictable, professional processing with the Buffalo Passport Agency located right in downtown Buffalo.",
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission — no 375-mile drive needed", "Ideal for UB students studying abroad in Europe or Asia", "Perfect for M&T Bank and Rich Products executives traveling internationally", "Great for WNY families flying BUF to Cancun, Punta Cana, or Fort Myers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service at Buffalo post offices", "Good for planned international trips from BUF", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required at Erie County facilities", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required at Buffalo Passport Agency — located in downtown Buffalo", "No walk-ins accepted at any regional agency", "Life-or-death emergencies only — bereavement or medical crisis", "Must prove travel within 72 hours with printed itinerary", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BUF flight to Cancun in two days? Last-minute Toronto business meeting? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Buffalo-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Buffalo residents renew fast — no agency visit required for most renewals. Perfect for downtown professionals, Amherst families, and Niagara Falls border commuters.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Buffalo residents through every step — from Elmwood Village to Williamsville to Niagara Falls — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your winter escape to Florida or spring break to the Caribbean stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Western New York family vacation to Punta Cana stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Buffalo professionals after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Buffalo corporate executives at M&T Bank, Moog Aerospace, and Delaware North who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Western New York travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Especially popular with Buffalo-Niagara residents crossing into Canada regularly.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Buffalo NY", description: "Urgent passport processing for Buffalo New York travelers with immediate departure needs from BUF Airport." },
    { name: "Expedited Passport Renewal Buffalo NY", description: "Fast passport renewal for Buffalo New York residents with a previously-issued passport." },
    { name: "First-Time Passport Buffalo NY", description: "New passport application services for Buffalo New York residents applying for their first passport." },
    { name: "Child Passport Buffalo NY", description: "Minor passport services for Buffalo New York families with children under 16." },
    { name: "Name Change Passport Buffalo NY", description: "Passport name correction after marriage, divorce, or legal name changes for Buffalo residents." },
    { name: "Second Passport Buffalo NY", description: "Second passport services for Buffalo corporate executives and frequent cross-border travelers." },
  ],
  testimonials: [
    {
      name: "Mark R.",
      location: "Elmwood Village, Buffalo",
      rating: 5,
      text: "My company sent me to Toronto on 4 days notice and my passport was expired. Fast Passport Center got it back in 48 hours. The document review caught a photo issue I would have missed. Incredible service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Kowalski Family",
      location: "Amherst",
      rating: 5,
      text: "We booked a family trip to Poland and realized our son's passport expired 3 months ago. They walked us through the child passport process and the passport arrived in 5 days. We made our flight to Warsaw with time to spare.",
      service: "Child Passport Renewal",
    },
    {
      name: "Lisa H.",
      location: "Cheektowaga",
      rating: 5,
      text: "I needed a name change on my passport before a conference in Toronto. They handled everything remotely — I never had to visit an office. Smooth, fast, professional.",
      service: "Name Change Passport",
    },
    {
      name: "David C.",
      location: "North Buffalo",
      rating: 5,
      text: "Third time using Fast Passport Center for BUF-to-Florida and Caribbean trips. They caught that my passport only had 4 months left before my Punta Cana trip — saved me from being denied boarding. Won't use anyone else.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "buf-1",
      name: "Buffalo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 William St",
      city: "Buffalo",
      state: "NY",
      zip: "14240",
      phone: "(716) 846-2101",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Buffalo",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Downtown Buffalo's primary passport acceptance facility. Photo services on-site. Busiest facility in Erie County — book appointments 2+ weeks ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "buf-2",
      name: "Amherst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5200 Main St",
      city: "Amherst",
      state: "NY",
      zip: "14221",
      phone: "(716) 832-2275",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Amherst — Northtowns",
      website: "https://tools.usps.com/find-location.htm?location=1377543",
      websiteLabel: "USPS Location",
      notes: "Convenient for Amherst, Williamsville, and Snyder residents. Passport photos available. Limited Saturday hours — call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "buf-3",
      name: "Cheektowaga Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1250 French Rd",
      city: "Cheektowaga",
      state: "NY",
      zip: "14227",
      phone: "(716) 668-2374",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Cheektowaga — near BUF Airport",
      website: "https://tools.usps.com/find-location.htm?location=1387618",
      websiteLabel: "USPS Location",
      notes: "Serves Cheektowaga, Depew, and airport-area residents. No weekend hours. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "buf-4",
      name: "Erie County Clerk — Downtown Buffalo",
      type: "County Clerk Passport Acceptance",
      address: "92 Franklin St",
      city: "Buffalo",
      state: "NY",
      zip: "14202",
      phone: "(716) 858-8785",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Buffalo",
      website: "https://www.erie.gov/clerk/",
      websiteLabel: "Erie County Clerk",
      notes: "County-operated passport acceptance. Marriage records available for name change documentation. Appointment recommended — walk-in availability limited.",
      icon: "ri-government-line",
    },
    {
      id: "buf-5",
      name: "Niagara Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "615 Main St",
      city: "Niagara Falls",
      state: "NY",
      zip: "14302",
      phone: "(716) 285-7511",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Niagara Falls — Niagara County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Niagara Falls and northern Erie County. Popular for cross-border commuters. Limited appointment slots — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "buf-6",
      name: "Hamburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "180 Buffalo St",
      city: "Hamburg",
      state: "NY",
      zip: "14075",
      phone: "(716) 649-1425",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Hamburg — Southtowns",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Southtowns option for Hamburg, Orchard Park, and Eden residents. Walk-in availability subject to clerk schedule.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out at NYC agency, 375 miles away", fpc: "No appointment needed to start — ship from home" },
    { feature: "In-Person Visit", agency: "Required — drive visit in person at the Buffalo Passport Agency in downtown Buffalo", fpc: "Most Buffalo travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel within 72 hours", fpc: "As fast as 24 hours — multiple speed options available" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay of 2+ weeks", fpc: "Professional review to catch photo issues, form errors, and missing signatures" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only on tight eligibility", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee of service", fpc: "Predictable processing based on selected speed option with guaranteed turnaround" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation, no travel proof needed" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle 375-mile drive and all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Buffalo-Specific Guidance", agency: "Generic — no BUF airport, cross-border Canada, or UB/university expertise", fpc: "Full Buffalo/WNY/cross-border/university knowledge built into our service" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Enhanced License Works for Air Travel to Canada",
      description: "Many Buffalo residents use enhanced driver's licenses for land crossing to Canada, but these are NOT valid for air travel. If you fly BUF to Toronto or Montreal, you still need a passport book — not just an EDL or passport card.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Buffalo applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Buffalo-area CVS and Walgreens locations produce photos that fail State Department standards — wrong background shade, incorrect head size, or shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Western New York families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection for child passports — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Validity Rule",
      description: "Buffalo travelers booking to the Caribbean, Mexico, or Europe often do not know their passport must have 6 months remaining beyond the return date. Many Caribbean nations strictly enforce this — we flag it immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or UB dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Buffalo clients ship from home or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 375 miles to Manhattan or wait for a post office appointment." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Buffalo?", a: "We offer Buffalo-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays — especially important for cross-border Buffalo travelers." },
    { q: "Do I need to visit a Buffalo office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Buffalo-area post office or Erie County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Buffalo address." },
    { q: "Where can I get passport acceptance in Buffalo?", a: "Buffalo has acceptance facilities at the Main Post Office on William Street, Amherst Post Office on Main Street, Cheektowaga Post Office on French Road, and the Erie County Clerk downtown. We maintain an updated list of Buffalo-area facilities with hours, photo availability, and appointment options." },
    { q: "Can I use my enhanced driver's license to fly to Canada?", a: "No — enhanced driver's licenses (EDLs) are only valid for land and sea crossings to Canada, Mexico, and the Caribbean. For air travel to Canada or any international destination, you need a valid U.S. passport book. Many Buffalo travelers learn this the hard way at BUF check-in." },
    { q: "What is the best price for expedited passport service in Buffalo?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Does the Buffalo Passport Agency serve Buffalo walk-ins?", a: "The Buffalo Passport Agency (111 Genesee Street Suite 101, downtown Buffalo) requires appointments for life-or-death emergency travel only. Walk-ins may be accepted for true emergencies. For travel within 3–14 days, our registered courier service offers the fastest legally available processing." },
    { q: "Can I get a passport photo in Buffalo?", a: "Yes — many Buffalo-area CVS, Walgreens, UPS Stores, and FedEx Office locations offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does cross-border travel affect Buffalo passport needs?", a: "Buffalo's proximity to Canada (90 minutes to Toronto) means many residents cross the border frequently. For land crossings, a passport card or enhanced license works. For air travel to Canada or beyond, you need a passport book. We help Buffalo travelers get the right document for their specific travel type." },
    { q: "Can you help with passports for UB study abroad students?", a: "Yes. University at Buffalo sends thousands of students abroad annually. Many are first-time passport applicants. We guide UB students through the acceptance facility process with the nearest available appointment, so they do not miss program orientation deadlines." },
    { q: "What about BUF Airport international flights?", a: "Buffalo Niagara International Airport offers seasonal international flights to Cancun, Punta Cana, Fort Myers, and Toronto, plus connecting service to global hubs. We help Buffalo travelers get expedited passports with enough lead time before their BUF departure." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Buffalo Residents",
    intro: "Buffalo's unique position as a border city with strong Canadian ties and a growing international airport creates distinct passport timing challenges. Here's what Buffalo travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BUF — Buffalo Niagara International Airport",
        subtitle: "Western New York's primary airport, 5M+ annual passengers",
        description: "BUF handles more than 5 million passengers annually with seasonal international flights to Cancun, Punta Cana, and Toronto, plus connecting service to global hubs through Atlanta, Charlotte, Chicago, and New York. The airport's growing route network creates regular passport urgencies — families booking spring break packages to Mexico, snowbirds heading to Florida who realize their passport expired, and UB international students returning home for breaks.",
        tip: "BUF's seasonal international routes (Cancun, Punta Cana) operate November through April. If you book a winter escape package, check your passport expiration immediately — these flights fill fast and you cannot change your departure date.",
      },
      {
        icon: "ri-flag-line",
        title: "Cross-Border Canada Travel — Peace Bridge & Niagara Crossings",
        subtitle: "90 minutes to Toronto, multiple land crossings",
        description: "Buffalo's proximity to Canada is unmatched in the U.S. — Toronto is a 90-minute drive, Niagara-on-the-Lake is 45 minutes, and Montreal is 5 hours. The Peace Bridge (Buffalo-Fort Erie), Rainbow Bridge (Niagara Falls), and Lewiston-Queenston Bridge handle millions of crossings annually. Many Buffalo residents have family on both sides of the border, attend events in Toronto, or commute for work. The confusion between enhanced licenses, passport cards, and passport books creates constant urgent requests.",
        tip: "Enhanced driver's licenses work for land crossings to Canada but NOT for air travel. If there is any chance you will fly to Toronto Pearson (YYZ) instead of driving, get a passport book — do not rely on your EDL alone.",
      },
      {
        icon: "ri-building-2-line",
        title: "Corporate Travel & Western New York Business",
        subtitle: "M&T Bank, Rich Products, Moog Aerospace, Delaware North",
        description: "Buffalo's corporate landscape includes major employers with international operations. M&T Bank has cross-border banking relationships. Moog Aerospace serves global aviation clients. Rich Products operates in 100+ countries. Delaware North manages concessions at airports and stadiums worldwide. When these companies send executives abroad — often on short notice for client meetings, supplier visits, or site inspections — passport urgencies emerge that standard post office processing cannot handle.",
        tip: "Buffalo corporate travelers often cross into Canada for same-day meetings using only an enhanced license. But international air travel from BUF or Toronto Pearson requires a passport book — check your passport before booking any flight, even a short one.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University at Buffalo & WNY College Study Abroad",
        subtitle: "UB, Buffalo State, Canisius, Niagara University",
        description: "The University at Buffalo alone has over 32,000 students, including one of the largest international student populations in the SUNY system. UB, Buffalo State, Canisius College, and Niagara University collectively send thousands of students abroad each year for semester exchanges, summer programs, and spring break immersions. Many UB students — especially first-generation college students — have never had passports. The acceptance-to-departure pipeline is often 6–10 weeks, requiring expedited processing to meet program deadlines.",
        tip: "UB's study abroad application deadlines typically fall in October for spring programs and March for fall programs. First-time applicants need an acceptance facility visit — we help students find the nearest available appointment so they do not miss orientation.",
      },
    ],
    callout: {
      icon: "ri-snowy-line",
      title: "Buffalo Snowbird Season & Winter Escapes",
      description: "Buffalo's legendary winters drive a massive seasonal migration. From January through March, thousands of Western New Yorkers flee to Florida, the Caribbean, and Mexico. Many discover their passport expired only when packing — creating a predictable late-December and January rush. Plan ahead: if you even suspect you will book a winter escape, check your passport in October.",
    },
  },
  destinations: {
    title: "Where Buffalo Travelers Go — And Why Passports Get Urgent",
    intro: "Buffalo's location, heritage communities, and airport connections shape where Western New Yorkers travel internationally. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Buffalo expedited requests are cross-border Canada or winter escape related with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time from booking winter vacation package to BUF international departure" },
      { stat: "Jan–Mar", label: "peak snowbird season — Florida, Caribbean, and Mexico bookings collide with spring break" },
      { stat: "30 Hours", label: "shortest turnaround for a Buffalo executive flying to Toronto then connecting to London" },
    ],
    destinations: [
      { name: "Canada", context: "Toronto weekend getaways, Montreal family visits, Niagara-on-the-Lake wine tours, cross-border business at M&T Bank and Rich Products", urgency: "Cross-border same-day trips often booked with zero notice; air travel to Canada requires full passport book", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "BUF-Cancun seasonal direct flights, Riviera Maya resort packages, Playa del Carmen spring break, dental tourism in border cities", urgency: "All-inclusive resort deals booked 2–4 weeks out during Buffalo's brutal January–March winter", icon: "ri-map-pin-2-line" },
      { name: "Poland & Eastern Europe", context: "Massive Polish-American heritage community in Buffalo — Dyngus Day capital of America. Family heritage trips to Warsaw, Krakow, Gdansk", urgency: "Family reunions, weddings, and heritage tours announced 4–8 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Dominican Republic", context: "BUF-Punta Cana seasonal flights, all-inclusive resort vacations, family reunions in Santo Domingo, growing Dominican community in Buffalo", urgency: "Resort packages booked 3–5 weeks out, often for extended family groups needing multiple passports", icon: "ri-map-pin-2-line" },
      { name: "Italy & Ireland", context: "Strong Italian-American (Hertel Avenue) and Irish-American (South Buffalo) heritage. Heritage tours, dual citizenship applications, family research trips", urgency: "Jure sanguinis (Italian citizenship by descent) appointments require valid passport — booked months ahead but discovered late", icon: "ri-map-pin-2-line" },
      { name: "Caribbean Cruises", context: "Cruise departures from Florida ports accessible via BUF connections. Jamaica, Bahamas, Cayman Islands, Aruba", urgency: "Last-minute cruise deals booked 3–4 weeks before departure with multi-passenger passport emergencies", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "New York City", route: "/new-york-city" },
      { name: "Albany", route: "/albany-ny" },
      { name: "Syracuse", route: "/syracuse" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Elmwood Village", address: "564 Elmwood Ave, Buffalo, NY 14222", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Delaware Ave", address: "650 Delaware Ave, Buffalo, NY 14202", hours: "Mon–Fri 8 AM – 10 PM, Sat–Sun 9 AM – 6 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Amherst", address: "3380 Sheridan Dr, Amherst, NY 14226", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Williamsville", address: "5310 Main St, Williamsville, NY 14221", hours: "Mon–Fri 7 AM – 9 PM, Sat 8 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "UPS Store — North Buffalo", address: "1460 Hertel Ave, Buffalo, NY 14216", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Cheektowaga", address: "3800 Union Rd, Cheektowaga, NY 14225", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Hamburg", address: "5999 South Park Ave, Hamburg, NY 14075", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Photo Center — Amherst", address: "1540 Military Rd, Niagara Falls, NY 14304", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Buffalo (Downtown)",
      address: "170 Pearl St, Buffalo, NY 14202",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Downtown Buffalo DMV. REAL ID, driver's license renewals, and enhanced licenses available. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Amherst",
      address: "1085 Niagara Falls Blvd, Amherst, NY 14226",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Northtowns DMV serving Amherst and Tonawanda. Enhanced license and REAL ID processing.",
      featured: false,
    },
    {
      name: "NYS DMV — Cheektowaga",
      address: "2122 George Urban Blvd, Cheektowaga, NY 14225",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Cheektowaga DMV near BUF Airport. Convenient for Depew and Lancaster residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "In Cheektowaga, 8 miles from downtown Buffalo",
      address: "4200 Genesee St, Buffalo, NY 14225",
      note: "Western New York's primary airport with seasonal international flights to Cancun, Punta Cana, and Toronto, plus connecting service to global hubs via Atlanta, Charlotte, Chicago, and New York. 5M+ annual passengers.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Niagara Airport",
      featured: true,
    },
    {
      code: "YYZ",
      name: "Toronto Pearson International Airport",
      distance: "90 miles from Buffalo (in Canada)",
      address: "6301 Silver Dart Dr, Mississauga, ON L5P 1B2, Canada",
      note: "Canada's largest international airport with direct flights to Europe, Asia, and South America. Many Buffalo residents use Toronto Pearson for international long-haul travel at significantly lower fares than U.S. connections.",
      flightUrl: "https://www.torontopearson.com/",
      flightLabel: "Toronto Pearson Airport",
      featured: false,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "70 miles from Buffalo",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Alternative regional airport with domestic connections. Useful for Buffalo-area travelers when BUF routes are fully booked.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health. Online, mail, or in-person options available for Erie County births.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYSDOH Vital Records. Required for estate and legal matters in Erie County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Erie County Clerk. Certified copies available for name changes and legal purposes at 92 Franklin Street, Buffalo.",
      url: "https://www.erie.gov/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Erie County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/8jd/erie/",
    },
  ],
};

export default buffaloConfig;